import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'cstmsr-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class ToggleComponent {

	protected _on: boolean | undefined;
	@Input() set on(value: boolean | undefined) {
		this._on = value;
		this.set();
	};

	protected _color: string;
	@Input() set color(value: string) {
		this._color = value;
		this.setCssVar('--toggle-background-color', this._color, this.elRef.nativeElement)
	}

	@Input() disabled = false;

	@Output() valueChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(
		private elRef: ElementRef<HTMLElement>
	) { }

	toggle() {
		this._on = !this._on;

		this.set();

		this.valueChanged.emit(this._on);
	}

	set() {
		if (this._on) {
			this.setCssVar('--toggle-background-color', this._color, this.elRef.nativeElement);
		}
		else {
			this.setCssVar('--toggle-background-color', 'gray', this.elRef.nativeElement);
		}

	}

	getCssVar(name: string, el: HTMLElement) {
		return getComputedStyle(el).getPropertyValue(name);
	}

	setCssVar(name: string, value: string, el: HTMLElement) {
		el.style.setProperty(name, value);
		return this.getCssVar(name, el);
	}

}
